import React, { forwardRef } from 'react'
import { Controller } from 'react-hook-form'
import { GridContainer, GridItem } from 'components/Grid'
import CustomAutocomplete from 'components/CustomAutocomplete'
import { Button } from 'components/CustomButtons'
import { SLOT_LABEL, FEE_LABEL } from 'config/app'
import Drawer from 'components/Drawer'
import { useEffect } from 'react'
import useOpenClose from 'hooks/useOpenClose'

const SlotDateChooserForm = forwardRef(({ slots, onSave, onClose, hookForm }, ref) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
    watch,
  } = hookForm
  const slot = watch('slot')
  const { open } = useOpenClose(ref);

  useEffect(() => {
    setValue('fee', null)
  }, [slot])

  return (
    <Drawer open={open}>
      {open && (
        <form onSubmit={handleSubmit(onSave)}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Controller
                control={control}
                name="slot"
                render={({ field }) => (
                  <CustomAutocomplete
                    {...field}
                    label={`Choose a ${SLOT_LABEL}`}
                    options={slots?.data}
                    optionLabel="name"
                    optionValue="id"
                    error={errors.slot}
                    fullWidth
                  />
                )}
              />
            </GridItem>
          </GridContainer>
          {slot && slot?.fees.length > 0 && (
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <Controller
                  control={control}
                  name="fee"
                  render={({ field }) => (
                    <CustomAutocomplete
                      {...field}
                      label={`Choose ${FEE_LABEL}`}
                      options={slot?.fees}
                      optionLabel="name"
                      optionValue="id"
                      error={errors.fee}
                      fullWidth
                    />
                  )}
                />
              </GridItem>
            </GridContainer>
          )}
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Button type="submit" color="primary" variant="contained" style={{ marginRight: 10 }}>
                Save
              </Button>
              <Button onClick={onClose}>
                Close
              </Button>
            </GridItem>
          </GridContainer>
        </form>
      )}
    </Drawer>
  )
})
export default SlotDateChooserForm
